import { render, staticRenderFns } from "./EmptyScreen.vue?vue&type=template&id=a4640bc4&scoped=true&"
import script from "./EmptyScreen.vue?vue&type=script&lang=js&"
export * from "./EmptyScreen.vue?vue&type=script&lang=js&"
import style0 from "./EmptyScreen.vue?vue&type=style&index=0&id=a4640bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4640bc4",
  null
  
)

export default component.exports